import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '@/store';

export const childApplyListSelector = createSelector(
  (state: RootState) => state.childApply.childApplyList,
  (childApplyList) => childApplyList,
);

export const isInitChildApplySelector = createSelector(
  (state: RootState) => state.childApply,
  (item) => item.nextTokenChildApply !== null,
);

export const isEnableLoadingChildApplySelector = createSelector(
  (state: RootState) => state.childApply,
  (item) => item.nextTokenChildApply !== '',
);

export const childRemoveListSelector = createSelector(
  (state: RootState) => state.childApply.childRemoveList,
  (childRemoveList) => childRemoveList,
);

export const applyNurseryListSelector = createSelector(
  (state: RootState) => state.childApply.applyNurseryList,
  (applyNurseryList) => applyNurseryList || [],
);

export const isInitApplyNurseryListSelector = createSelector(
  (state: RootState) => state.childApply.applyNurseryList,
  (applyNurseryList) => applyNurseryList !== null,
);

export const isInitChildRemoveSelector = createSelector(
  (state: RootState) => state.childApply,
  (item) => item.nextTokenChildRemove !== null,
);

export const isEnableLoadingChildRemoveSelector = createSelector(
  (state: RootState) => state.childApply,
  (item) => item.nextTokenChildRemove !== '',
);
